import React, {Component} from 'react';
import * as api from "../../../utils/api/api";
import { FormField } from "components/common/FormField.component";
import { TextInput } from "components/common/TextInput.component";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes, DropdownPosition } from "types/gaiaComponents/dropdownButton.types";

export class SimulatorAmount extends Component {

    constructor(props) {
        super(props);
        this.currencies = ['NOK', 'SEK', 'DKK', 'EUR', 'RON'];
    }

    componentDidMount() {
        this.getCurrency();
    }

    getCurrency(){
        api.getCurrencyCode(this.props.currentContextId).then((response) => {
            if(response){
                this.props.onCurrencyChange({
                    target: {
                        value: response
                    }
                })
            }
        })
    }

    getCurrencyItems() {
        return this.currencies.map((currency) => ({
            key: currency,
            text: currency,
            onClick: () => {
                this.props.onCurrencyChange({
                    target: {
                        value: currency
                    }
                });
            }
        }));
    }

    render() {
        return (
            <div className="form-group">
                <div className="form-group form-inline d-flex gap-8">
                    <FormField
                        id="simulator-amount"
                        label={this.props.translate("workflowDetails.simulator.amount")}>
                        <TextInput
                            type="number"
                            className="ga-input__amount"
                            value={this.props.amount}
                            onChange={this.props.onAmountChange}
                            invalid={!this.props.valid}
                            min={1}
                        />
                    </FormField>
                    <div className="form-group mb-16 align-self-end">
                        <DropdownSelect
                            id="simulator-currency"
                            type={DropdownSelectTypes.VALUE}
                            value={this.props.currency}
                            items={this.getCurrencyItems()}
                            position={DropdownPosition.BOTTOM_LEFT}
                        />
                    </div>
                </div>
            </div>
        );
    }
}